import Image from '@components/Image'
import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { useInView } from 'react-intersection-observer'
import { ElementHTML } from '@helpers/helper.rendering'

const AboutUs4 = (props: RealEstateDataPageComponentData) => {
  const {
    items,
    bioAnimation,
    titleElement,
    paragraphElement,
    paragraphColor,
    paragraphHexa,
    customFontSize,
  } = props

  useEffect(() => {
    AOS.init({ duration: 2000 })
  }, [])

  const { ref, inView } = useInView({
    triggerOnce: false, // Cargar solo una vez cuando sea visible
  })

  return (
    <section
      ref={ref}
      className="about-history position-relative p-y-config a overflow-hidden"
    >
      <Container
        fluid
        id="checkContainer"
      >
        <Row className="content-history">
          <Col
            xs={12}
            className="text-center"
          >
            {items?.map((item, index) => (
              <Row
                key={index}
                className="article-history py-lg-4 py-2"
              >
                <Col
                  xs={12}
                  className={
                    (inView && bioAnimation
                      ? ' animate__animated animate__fadeIn' + (index % 2 == 1 ? 'Right ' : 'Left ')
                      : '') + 'd-lg-flex align-items-strech'
                  }
                >
                  <Row className="row">
                    <Col
                      lg={{ span: 6, offset: 0, order: item.align === 'left' ? 1 : 2 }}
                      xs={{ span: 12, offset: 0, order: 2 }}
                    >
                      <Image
                        className="w-100"
                        objectFit="cover"
                        alt="about-us-3-img"
                        image={item.image_gatsby!}
                      />{' '}
                    </Col>
                    <Col
                      lg={{ span: 6, offset: 0, order: item.align === 'left' ? 2 : 1 }}
                      xs={{ order: 1 }}
                      className="ps-lg-5 pe-lg-5 d-flex flex-column justify-content-center text-start "
                    >
                      <ElementHTML
                        elementType={titleElement || 'h1'}
                        children={item!.titles![0]}
                        style={{ fontSize: customFontSize ? customFontSize + 'rem' : '' }}
                        className="mb-xl-4 mb-2"
                      />
                      {item!.subtitles?.length == 2 && item!.subtitles![0] !== ' ' && (
                        <h2 className="mb-lg-2 text-start">{item!.subtitles![0]}</h2>
                      )}
                      {/* <p className="mb-lg-5 text-start">{item!.paragraphs![0]}</p> */}
                      {item!.paragraphs![0]?.split('\n').map((paragraph_, index) => (
                        <ElementHTML
                          key={index}
                          elementType={paragraphElement || 'p'}
                          className={
                            'text-start ' +
                            (paragraphColor +
                              (index === item!.paragraphs![0]?.split('\n')?.length - 1
                                ? ' mb-lg-5 '
                                : ''))
                          }
                          style={{ color: paragraphHexa }}
                          children={paragraph_}
                        />
                      ))}
                      <ElementHTML
                        elementType={titleElement || 'h1'}
                        style={{ fontSize: customFontSize ? customFontSize + 'rem' : '' }}
                        children={item!.titles![1]}
                        className="mb-xl-4 mb-2 mt-lg-3"
                      />
                      {item!.subtitles?.length == 2 && item!.subtitles![1] !== ' ' && (
                        <h2 className="mb-xl-2 mb-2">{item!.subtitles![1]}</h2>
                      )}
                      {item!.paragraphs![1]?.split('\n').map((paragraph_, index) => (
                        <ElementHTML
                          key={index}
                          elementType={paragraphElement || 'p'}
                          className={
                            'text-start ' +
                            (paragraphColor +
                              ' ' +
                              (index === item!.paragraphs![1]?.split('\n')?.length - 1
                                ? ' mb-lg-5'
                                : ''))
                          }
                          style={{ color: paragraphHexa }}
                          children={paragraph_}
                        />
                      ))}
                      {/* <p className="text-start mb-lg-5">{item!.paragraphs![1]}</p> */}
                    </Col>
                  </Row>
                </Col>
              </Row>
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AboutUs4
